<template>
  <!-- <transition name="fade" mode="out-in" appear > -->

    <div :id="'list-' + this.options.id" class="container-list"  :class="[options.type + ' list-'+ $store.getters.getData.template1, { 'control-bar-active': $store.getters.platform !== 'browser' && $store.getters.getData.control_bar }]">
      <h3 class="text-black-shadow">{{options.title}}</h3>

      <div v-show="showIcons" class="icon-list" style="left:0;" @click="prev">
        <icon ref="prev" name="chevron-left" scale="8"></icon>
      </div>

      <!-- <h1 class="text-black-shadow">{{options.title}}</h1> -->

      <div ref="list" class="list" :class="'list-' + $store.getters.platform">

        <div class="list-content">

          <div v-if="!options.items.length">
            <div class="item active" :style="{ width: itemWidth + 'px' }">
              <div  :style="{ width:  itemWidth + 'px', height:  itemHeight + 'px' }">
                  <div class="empty-list">
                    <span>Empty</span>
                  </div>
              </div>
            </div>
          </div>

          <ListItem v-else ref="items" v-for="item in options.items"  :class="[{ 'min-scale': minScale }]"
            :key="item.id"
            :wrapper="options.wrapper"
            :item="item"
            :size="size"
            :type="options.type"
            :typeCat="options.typeCat"
            :route="options.route"
            :backReplace='options.backReplace'
            @trailerPlay="trailerPlay($event)"
            @trailerStop="trailerStop($event)" />

        </div>
      </div>

      <div v-show="showIcons" class="icon-list" style="right:0;" @click="next">
        <icon ref="next" name="chevron-right" scale="8"></icon>
      </div>

    </div>

  <!-- </transition> -->
</template>

<script>
import Bus from '@/components/ControlBus'
import ListItem from '@/templates/default/components/list-item'
require('@/assets/js/sly.js')

export default {
  name: 'List',
  components: { ListItem },
  props: ['options'],
  data () {
    return {
      waiting: false,
      cardsSetting: { // default
        text: 'outside', // outside, inside or ''
        play: false, // true or false
        trailer: false, // true or false
        favorite: 'top' // top or bottom
      },
      itemWidth: false,
      itemHeight: false,
      showIcons: true,
      minScale: false
    }
  },
  created: function () { this.setSize() },
  mounted () {
    let speed = 0
    if (this.$store.getters.getData.template1 === 'VOD') { speed = 300 }
    var options = {
      horizontal: 1,
      itemNav: 'centered',
      smart: 1,
      activateOn: 'click',
      mouseDragging: 1,
      touchDragging: 1,
      releaseSwing: 1,
      startAt: 0,
      // scrollBar: $wrap.find('.scrollbar'),
      scrollBy: 0,
      speed: speed,
      elasticBounds: 1,
      // easing: 'easeOutExpo',
      dragHandle: 1,
      dynamicHandle: 1,
      clickBar: 1
      // prev: this.$refs['prev'].$el,
      // next: this.$refs['next'].$el
    }

    // bug sly => añadido slideeSize += itemSizeFull + 3; a fuente
    this.sly = new window.Sly(this.$refs['list'], options)
    this.sly.on('load', () => { setTimeout(() => this.getShowIcons(), 0) }) // iconos
    this.sly.init()

    // bug al redimensionar
    window.addEventListener('resize', () => {
      this.setSize()
      setTimeout(() => {
        if (this.$refs.list) { this.$refs.list.style.display = 'block' }
        this.sly.reload()
        if (this.$refs.list) { this.$refs.list.style.display = 'inline' }
      }, 0)
    })

    // if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
    //   this.$refs.list.style.setProperty('display', 'block', 'important')
    // }

    // actualizar favoritos / vistos
    Bus.$on('update-list', this.updateList)
  },
  methods: {
    prev: function () { this.$store.getters.platform === 'browser' ? this.sly.prevPage() : this.sly.prev() },
    next: function () { this.$store.getters.platform === 'browser' ? this.sly.nextPage() : this.sly.next() },
    trailerPlay: function (e) { this.$emit('dynamic-event', 'trailerPlay') },
    trailerStop: function (e) { this.$emit('dynamic-event', 'trailerStop') },
    updateList: function (e) {
      if ((this.options.typeCat === 'FAV' && e.action === 'add-favorite') || (this.options.typeCat === 'LAS' && e.action === 'add-viewed')) {
        // no duplicamos
        if (!this.options.items.filter(item => { return item.id === e.item.id }).length) {
          // max 10
          if (this.options.items.length >= 10) { this.options.items.splice(this.options.items.length - 1, 1) }
          this.options.items.unshift(e.item)
        }
        this.timeout = setTimeout(() => { this.sly.reload() }, 0)
      } else if (this.options.typeCat === 'FAV' && e.action === 'remove-favorite') {
        for (let i = 0; i < this.options.items.length; i++) {
          if (this.options.items[i].id === e.item.id) {
            this.options.items.splice(i, 1)
            this.timeout = setTimeout(() => { this.sly.reload() }, 0)
            break
          }
        }
      } else if (e.action === 'add-favorite') {
        for (let i = 0; i < this.options.items.length; i++) {
          if (this.options.items[i].id === e.item.id) {
            this.options.items[i].is_favorite = e.idFav
            break
          }
        }
      } else if (e.action === 'remove-favorite') {
        for (let i = 0; i < this.options.items.length; i++) {
          if (this.options.items[i].id === e.item.id) {
            this.options.items[i].is_favorite = 0
            break
          }
        }
      }
    },
    setSize () {
      // tamaño pantalla
      let windowWidth = window.innerWidth || document.documentElement.clientWidth
      // let windowHeight = window.innerHeight || document.documentElement.clientHeight

      //  tamaño tarjeta
      let cardWidth = ''; let cardHeight = ''
      if (this.options.card) {
        // especifico categoría
        cardWidth = this.options.card.width_ios
        cardHeight = this.options.card.height_ios
      } else if (this.options.type === 'card-categories' && this.$store.getters.getData.card_categories) {
        // categorías contenidos
        cardWidth = this.$store.getters.getData.card_categories.width_ios
        cardHeight = this.$store.getters.getData.card_categories.height_ios
      } else if (this.options.type === 'card-contents' && this.$store.getters.getData.card_contents) {
        // contenidos
        cardWidth = this.$store.getters.getData.card_contents.width_ios
        cardHeight = this.$store.getters.getData.card_contents.height_ios
      } else if (this.options.type === 'card-categories-products' && this.$store.getters.getData.card_categories_products) {
        // categorías tienda
        cardWidth = this.$store.getters.getData.card_categories_products.width_ios
        cardHeight = this.$store.getters.getData.card_categories_products.height_ios
      } else if (this.options.type === 'card-products' && this.$store.getters.getData.card_products) {
        // productos
        cardWidth = this.$store.getters.getData.card_products.width_ios
        cardHeight = this.$store.getters.getData.card_products.height_ios
      } else if (this.options.type === 'card-settings') {
        // settings
        cardWidth = 220
        cardHeight = 220
      } else {
        // default
        cardWidth = 400
        cardHeight = 220
      }

      // base FULL-HD
      this.itemWidth = (windowWidth * cardWidth) / 1920
      // this.itemHeight = (windowHeight * cardHeight) / 1080

      // breakpoints
      if (windowWidth < 700) { this.itemWidth = this.itemWidth * 1.4 }
      if (windowWidth < 450) { this.itemWidth = this.itemWidth * 1.9 }
      if (this.itemWidth > windowWidth) { this.itemWidth = windowWidth * 0.92 }
      if (cardWidth > 1700) { this.minScale = true }

      // calcular tamaño manteniendo relación de aspecto
      // (original height / original width) x new width = new height
      this.itemHeight = (cardHeight / cardWidth) * this.itemWidth
    },
    getShowIcons: function () {
      let windowWidth = window.innerWidth || document.documentElement.clientWidth

      if (this.$refs['list'] && this.$refs['list'].offsetWidth < windowWidth) {
        this.showIcons = false
      } else {
        this.showIcons = true
      }
    }
  },
  computed: {
    size: function () {
      return { width: this.itemWidth, height: this.itemHeight }
    }
  },
  beforeDestroy: function () {
    Bus.$off('update-list', this.updateList)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.container-list
  position: relative
  width: 100%
  max-width: initial
  outline: none
  user-select: none
  padding-left: 3vw
  padding-top: 1rem
  padding-bottom: 1rem

  h3
    // position: absolute
    font-size: 1.4rem
    margin: 0
    padding: 0
    margin-bottom: .5rem

  .icon-list
    position: absolute
    top: 0
    height: 100%;
    z-index: 1;
    color: #fff;
    cursor: pointer
    opacity: 0;

    display: flex
    display: -webkit-flex
    flex-direction: column
    justify-content: center
    -webkit-justify-content: center
    align-items: center
    -webkit-align-items: center

    .fa-icon
      filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .9))
      opacity: .5;

    .fa-icon:hover
      opacity: 1

  .list-browser
    display: inline // falla en samsung pero necesario para zoom

  .list
    width: 100%
    // padding-top: 2vw // para scale al seleccionar // 1vw
    // padding-bottom: 2vw // para scale al seleccionar
    // padding-right: 2vw // para scale al seleccionar
    // padding-left: 2.6vw // para scale al seleccionar

    .list-content
      display: inline-block

      // .item // en subcomponet

.control-bar-active
  padding-bottom: 2.6rem

.container-list:hover .icon-list
  opacity: 1

// .container-list:focus .item.active
//   z-index: 10;
//   transform: scale(1.2)
  // transition: transform .3s

// // marquee efect
// .container-list:focus .item.active .text
//     text-overflow: clip

// .container-list:focus .item.active .text span
//     display: inline-block
//     padding-left: 100%  // show the marquee just outside the paragraph
//     animation: marquee 10s linear infinite

// .marquee span:hover
//     animation-play-state: paused

/* Make it move */
// @keyframes marquee
//   0%   { transform: translate(0, 0); }
//   100% { transform: translate(-100%, 0); }

.empty-list
  height: 100%
  width: 100%
  font-size: 2rem
  font-weight: bold
  background-color: rgba(white, 0.1)

  display: flex
  display: -webkit-flex
  flex-direction: column
  justify-content: center
  -webkit-justify-content: center
  align-items: center
  -webkit-align-items: center

// SCALE BROWSER
.list-browser .item
  transform: scale(1)
  transition: transform .5s;
  z-index: 10

.list-browser .item:hover
  transform: scale(1.09)
  transition: transform .2s
  z-index: 11

.item.min-scale:hover
  transform: scale(1.04)!important

@media screen and (max-width: 576px)
  .list-browser .item
    transform: scale(1)!important

</style>



// WEBPACK FOOTER //
// src/templates/default/components/list.vue